import { render } from "./KSUpdateFrequency.vue?vue&type=template&id=a9c44132"
import script from "./KSUpdateFrequency.vue?vue&type=script&lang=js"
export * from "./KSUpdateFrequency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__